/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Plans_LabelInputs */

const tr_mesafeli_s3_plans_label = /** @type {(inputs: Mesafeli_S3_Plans_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Planları:`)
};

const en_mesafeli_s3_plans_label = /** @type {(inputs: Mesafeli_S3_Plans_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Plans:`)
};

const de_mesafeli_s3_plans_label = /** @type {(inputs: Mesafeli_S3_Plans_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementpläne:`)
};

const ru_mesafeli_s3_plans_label = /** @type {(inputs: Mesafeli_S3_Plans_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Планы подписки:`)
};

/**
* | output |
* | --- |
* | "Subscription Plans:" |
*
* @param {Mesafeli_S3_Plans_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_plans_label = /** @type {((inputs?: Mesafeli_S3_Plans_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Plans_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_plans_label(inputs)
	if (locale === "de") return de_mesafeli_s3_plans_label(inputs)
	if (locale === "ru") return ru_mesafeli_s3_plans_label(inputs)
	return tr_mesafeli_s3_plans_label(inputs)
});